<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card class="md-card-flat">
        <!-- <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Reclamaciones Pendientes</h4>
        </md-card-header>-->
        <md-card-content>
          <h3 class="reclamaciones-title">Reclamaciones Consumidor</h3>
          <md-table
            v-model="issues"
            table-header-color="green"
            class="paginated-table table-hover"
            @md-selected="onSelectIssue"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
          >
            <md-table-toolbar>
              <table>
                <tr>
                  <td style="width:15%">
                    <md-field>
                      <label for="pages">Por página</label>
                      <md-select v-model="pagination.perPage" name="pages">
                        <md-option
                          v-for="item in pagination.perPageOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                        >{{ item }}</md-option>
                      </md-select>
                    </md-field>
                  </td>
                  <td style="width:15%">
                    <md-field>
                      <label for="filtro_tipos">Tipos</label>
                      <md-select
                        v-model="selectedTipos"
                        name="filtro_tipos"
                        id="filtro_tipos"
                        multiple
                      >
                        <md-option value="Calidad">Calidad</md-option>
                        <md-option value="Cantidad">Cantidad</md-option>
                        <md-option value="Envoltorio">Envoltorio</md-option>
                      </md-select>
                    </md-field>
                  </td>
                  <td style="width:40%"></td>
                  <td style="width:15%">
                    <md-field>
                      <label for="filtro_estados">Estados</label>
                      <md-select
                        v-model="selectedEstados"
                        name="filtro_estados"
                        id="filtro_estados"
                        multiple
                      >
                        <md-option value="Nueva">Nueva</md-option>
                        <md-option value="Leída">Leída</md-option>
                        <md-option value="Pendiente de Datos">Pendiente de Datos</md-option>
                        <md-option value="En Proceso">En Proceso</md-option>
                        <md-option value="Resuelta">Resuelta</md-option>
                      </md-select>
                    </md-field>
                  </td>
                  <td style="width:15%">
                    <md-field>
                      <md-input
                        type="search"
                        class="mb-3"
                        clearable
                        style="width: 200px"
                        placeholder="Buscar"
                        v-model="searchQuery"
                      ></md-input>
                    </md-field>
                  </td>
                </tr>
              </table>
            </md-table-toolbar>
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-auto-select
              md-selectable="single"
              :class="getClass(item)"
            >
              <!-- <md-table-cell md-label="Id">{{ item._id }}</md-table-cell> -->
              <md-table-cell
                md-label="Fecha"
                md-sort-by="fecha"
                style="width:15%"
              >{{ getDateString(item.created_at) }}</md-table-cell>
              <!-- <md-table-cell md-label="Cliente/Consumidor">{{ item.category }}</md-table-cell> -->
              <md-table-cell md-label="Tipo" style="width:15%">{{ item.tipo }}</md-table-cell>
              <md-table-cell
                md-label="Nombre"
                style="width:40%"
                md-sort-by="nombre"
              >{{ item.nombre }}</md-table-cell>
              <md-table-cell md-label="Estado" style="width:15%">{{ item.status }}</md-table-cell>
              <md-table-cell
                md-label="Última Modificación"
                md-sort-by="fecha_modificacion"
                style="width:15%"
              >{{ getDateString(item.updated_at) }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} incidencias</p>
          </div>
          <div>
            <loading
              :active.sync="isLoading"
              :is-full-page="fullPage"
              :background-color="bgColor"
              :color="color"
              :height="height"
              :loader="loader"
              :opacity="1"
            ></loading>
          </div>
          <pagination
            class="pagination-no-border pagination-primary"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @input="changePage"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100">
      <issue-modal v-if="showIssueModal" @close="closeIssueModal" :issue="selectedIssue" />
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import IssueModal from "./IssueModal";
import { apiServer, staticServer, florette_web } from "@/globalVars.js";
import { Pagination } from "@/components";
import Loading from "vue-loading-overlay";
import swal from "sweetalert2";

export default {
  name: "reclamaciones-consumidor",
  components: { draggable, IssueModal, Pagination, Loading },
  props: {},
  methods: {
    log: function (evt) {},
    onSelectIssue(issue) {
      if (issue != null) {
        this.$emit("on-selected", issue);
      }
    },
    closeIssueModal() {
      this.showIssueModal = false;
    },
    getIssues() {
      let search = {
        pagination: this.pagination,
        sort: this.currentSort,
        sortOrder: this.currentSortOrder,
        text: this.searchQuery,
        estados: this.selectedEstados,
        categorias: this.selectedCategorias,
        tipos: this.selectedTipos,
      };
      this.$store.dispatch("reclamacionConsumidor/getReclamaciones", search);
      this.isLoading = true;
    },
    customSort(field) {
      this.getIssues(
        this.pagination.currentPage,
        this.pagination.perPage,
        null
      );
    },
    changePage(val) {
      this.getIssues(
        this.pagination.currentPage,
        this.pagination.perPage,
        null
      );
    },
    getDateString(value) {
      let d = new Date(value);
      return d.toLocaleString("es-ES", { timeZone: "Europe/Madrid" });
    },
    getClass(item) {
      switch (item.status) {
        case "Nueva":
          return "table-primary";
        case "En Proceso":
          return "table-warning";
        case "Pendiente de Datos":
          return "table-info";
        case "Resuelta":
          return "table-success";

        default:
          break;
      }
    },
  },
  data() {
    return {
      currentSort: "fecha",
      currentSortOrder: "desc",
      showIssueModal: false,
      selectedIssue: null,
      searchQuery: null,
      selectedEstados: ["Nueva", "Leída", "En Proceso", "Pendiente de Datos"],
      selectedCategorias: ["CONSUMIDOR"],
      selectedTipos: [],
      issues: [],
      total: 0,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      isLoading: false,
      color: "#43a047",
      loader: "dots",
      fullPage: true,
      height: 48,
      bgColor: "#ffffff",
    };
  },
  mounted() {
    this.getIssues();
  },
  watch: {
    searchQuery(value) {
      this.getIssues();
    },
    selectedEstados(value) {
      this.getIssues();
    },
    selectedTipos(value) {
      this.getIssues();
    },
    selectedCategorias(value) {
      this.getIssues();
    },
    status_reclamaciones() {
      if (this.$store.state.reclamacionConsumidor.status.loaded) {
        if (this.$store.state.reclamacionConsumidor.list != null) {
          this.issues = this.$store.state.reclamacionConsumidor.list.issues;
          this.total = this.$store.state.reclamacionConsumidor.list.total;
        } else {
          this.issues = [];
          this.total = 0;
        }
        this.isLoading = false;
      }
    },
  },
  computed: {
    status_reclamaciones() {
      return this.$store.state.reclamacionConsumidor.status;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.reclamaciones-title {
  margin-top: 0px;
}
.header-control-1 {
  width: 19%;
  padding: 5px;
}
.header-control-2 {
  width: 23%;
  padding: 5px;
}
.table-primary {
  background-color: #b2dfdb;
}
.header-panel {
  padding-bottom: 20px;
}
.panel-cards {
  background-color: lightgray;
}
.user-avatar {
  border-radius: 50%;
  width: 34px;
  height: 34px;
  overflow: hidden;
  margin-top: 20px;
  margin-right: 0px;
  float: right;
}
</style>

